import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/Button';

export function UserProfileMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="user-profile-menu">
      <div className="user-info">
        <span className="user-name">{user.fullName}</span>
        <span className={`role-badge role-badge-${user.role.toLowerCase()}`}>
          {user.role}
        </span>
        <span className="user-email">{user.email}</span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="logout-btn"
        onClick={handleLogout}
      >
        Logout
      </Button>
    </div>
  );
}

export default UserProfileMenu;
